export enum CommandStatusEnum {
    WINCH_DELIVERY = 'WINCH_DELIVERY',
    DELIVERY_COMPLETED = 'DELIVERY_COMPLETED',
    START_MANUAL_CONTROL = 'START_MANUAL_CONTROL',
    WINCH_LOCK = 'WINCH_LOCK',
    WINCH_UNLOCK = 'WINCH_UNLOCK',
    WINCH_REEL_DOWN = 'WINCH_REEL_DOWN',
    WINCH_REEL_UP = 'WINCH_REEL_UP',
    REQUEST_RECORDING = 'REQUEST_RECORDING',
}